/**
 * Type definitions for asset paths to ensure type safety at compile time.
 */
type HotspotImagePath = `/images/hotspots/${string}.png`
type LogoPath = `/images/logos/${string}.webp`
type ImagePath = `/images/${string}.webp`
type VideoPath = `/videos/${string}.mp4` | `/videos/${string}.webm`
type AudioPath = `/audio/${string}.mp3`
type SubtitlePath = `/subtitles/${string}.vtt`
type ThumbnailPath = `/thumbs/chapter-${string}/thumb-${string}.jpg`

/**
 * Union type for all valid asset paths.
 */
type AssetPath = HotspotImagePath | LogoPath | ImagePath | VideoPath | AudioPath | SubtitlePath | ThumbnailPath

/**
 * Utility function to get the full URL for assets based on the NEXT_PUBLIC_ASSET_URL environment variable.
 * This allows assets to be served from different locations (CDN, subdomains, etc.)
 *
 * @param path - The asset path (must match one of the defined AssetPath types)
 * @returns The full asset URL
 */
export const getAssetUrl = (path: AssetPath): string => {
  const base = process.env.NEXT_PUBLIC_ASSET_URL || '/'

  // If base is just '/', return the path as-is
  if (base === '/') {
    return path
  }

  // Remove trailing slash from base and prepend to path
  return base.replace(/\/$/, '') + path
}
